/*=========================================================================================
  File Name: state.js
  Description: Order Manager State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
    capacity : 1,
    currentWaitingTime : 5,
    minWaitingTime : 5,
    maxWaitingTime : 20,
    cannotOrderNow : false,
    increaseTimeStep : 2,
    pendingOrdersIncreaseStep : 2,
    initTimeOfOrder : 2,
    offTime : null
}